import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

export const ForbiddenPage = (): React.ReactElement => {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="دسترسی غیرمجاز"
      subTitle="مجوز لازم برای مشاهده این بخش در نقش فعلی شما وجود ندارد."
      extra={<Button type="primary" onClick={() => navigate('/dashboard')}>بازگشت به داشبورد</Button>}
    />
  );
};
